import React from "react"

import { Container, FlexContainer } from "@carrotfertility/carotene"
import { BlueBottomBackground } from "./components/BlueBottomBackground"
import { LogoHeaderBar } from "./components/LogoHeaderBar"
import { GuideParser } from "./GuideParser"
import { GuideRouter } from "./GuideRouter"
import { createErrorBoundary } from "../../utils/createErrorBoundary"
import { ErrorPage } from "../../components/views/app/ErrorPage"
import useBenefit from "../../components/dynamic-content/hooks/useGetBenefit"
import useGetCategories from "../../components/read/shared/useGetCategories"
import { FullScreenLoading } from "../../components/read/shared/FullScreenLoading"

const ImmersiveGuide = (): JSX.Element => {
  const GuideErrorBoundary = createErrorBoundary(ErrorPage)
  const { isLoading: isBenefitLoading } = useBenefit()
  const { isLoading: isCategoriesLoading } = useGetCategories()

  return (
    <GuideErrorBoundary>
      <Container minHeight="100vh" background={"lightBlue"} sx={{ boxSizing: "border-box", position: "relative" }}>
        <LogoHeaderBar />
        <FlexContainer justifyContent="center" width="100%" padding={["medium", "medium", "medium", "0 0 128px 0"]}>
          <Container
            borderRadius="8px"
            width={["100%", "100%", "900px"]}
            minHeight={["60vh", "60vh", "auto", "auto"]}
            height={["auto", "auto", "auto", "700px"]}
            background={"white"}
            sx={{ zIndex: 1 }}
          >
            {isBenefitLoading || isCategoriesLoading ? (
              <FullScreenLoading />
            ) : (
              <GuideParser GuideComponent={GuideRouter} />
            )}
          </Container>
        </FlexContainer>
        <BlueBottomBackground />
      </Container>
    </GuideErrorBoundary>
  )
}

export { ImmersiveGuide }
